export * from "./components";

// Add types from Chameleon, without importing any JS in the final bundle.
// Don't use 'import "@genexus/chameleon-controls-library"'
typeof import("@genexus/chameleon-controls-library/dist/types/index");

import nexaAvatar from "./components/chat/chat-welcome/gx-ide-assets/chat-welcome/images/ai-avatar.svg";
export { nexaAvatar };

import nexaAvatarCommon from "./common/images/ai-avatar.svg";
export { nexaAvatarCommon };
